// React
import React from "react";

// Styles
import './toggle.css';
import '../../assets/css/animations.css';

const Toggle = (props) => (

    <div className="checkbox checkbox-switchery switchery-xs switchery-double">
        <label>
            BTC
            <input type="checkbox" className="switchery" checked="checked" data-switchery="true" style={{display: 'none'}}/>
            <span class="switchery switchery-default" style={{backgroundColor: 'rgb(100, 189, 99)', borderColor: 'rgb(100, 189, 99)', boxShadow: 'rgb(100, 189, 99) 0px 0px 0px 8px inset', transition: 'border 0.4s, boxShadow 0.4s, backgroundColor 1.2s'}}>
                <small style={{left: '14px', backgroundColor: 'rgb(255, 255, 255)', transition: 'backgroundColor 0.4s, left 0.2s'}}></small>
                </span>
            USD
        </label>
    </div>

    
);

export default Toggle;



// WEBPACK FOOTER //
// ./src/Components/Panels/Toggle.js